export const SET_IDG_CONTENT = 'IDGGlobalContext.SET_IDG_CONTENT';
export const SET_PATIENT_IDG_MANIFEST = 'IDGGlobalContext.SET_PATIENT_IDG_MANIFEST';
export const SET_REVIEW_COMPLETE = 'IDGGlobalContext.SET_REVIEW_COMPLETE';
export const SET_LAST_IDG_INFO = 'IDGGlobalContext.SET_LAST_IDG_INFO';
export const SET_DOCUMENT_ID = 'IDGGlobalContext.SET_DOCUMENT_ID';
export const SET_DOCUMENT_DATA = 'IDGGlobalContext.SET_DOCUMENT_DATA';
export const RESET_IDG_DATA = 'IDGGlobalContext.RESET_IDG_DATA';
export const SET_ALL_IDG_QUESTIONNAIRES = 'IDGGlobalContext.SET_ALL_IDG_QUESTIONNAIRES';
export const SET_LOADER = 'IDGGlobalContext.SET_LOADER';
export const SET_IDG_LIST_DATA = 'IDGGlobalContext.SET_IDG_LIST_DATA';
export const TeamReviewAndAcceptance = 'Team Review and Acceptance';